import { BLACKLIST } from '../../../../ContactSales/constants';
import { PROFESSIONAL_EMAIL_ERROR } from '../../../../ContactSales/utils/constants';

const EMAIL_REGEX = /\S+@\S+\.\S+/;
const MOBILE_NO_REGEX = /^\d{10}$/;
export const VALIDATION_ENUMS = {
  IS_REQUIRED: 'REQUIRED',
  IS_EMAIL: 'IS_EMAIL',
  IS_BUSINESS_EMAIL: 'IS_BUSINESS_EMAIL',
  IS_PHONE: 'IS_PHONE_NUMBER',
};

export const emailValidator = (email: string, fieldName: string): string => {
  if (!email) return `${fieldName} is required`;

  if (!new RegExp(EMAIL_REGEX).test(email)) return 'Incorrect email format';

  return '';
};

export const businessEmailValidator = (
  email: string,
  fieldName: string
): string => {
  const emailError = emailValidator(email, fieldName);

  if (emailError !== '') return emailError;

  const atIndex = email.indexOf('@');
  const domain = email.slice(atIndex + 1);
  if (BLACKLIST.includes(domain)) {
    return PROFESSIONAL_EMAIL_ERROR;
  }
  return '';
};

export const requiredValidator = (value: string, fieldName: string): string => {
  if (!value) return `${fieldName} is required`;

  return '';
};

export const phoneValidator = (value: string, fieldName: string): string => {
  if (!value) return `${fieldName} is required`;

  if (!new RegExp(MOBILE_NO_REGEX).test(value))
    return `${fieldName} can only contain 10 digits`;

  return '';
};
